// extracted by mini-css-extract-plugin
module.exports = {"dashboardRateCardList":"DashboardRateCardList_dashboardRateCardList__3uSkQ","dashboardRateCard":"DashboardRateCardList_dashboardRateCard__jOCIB"};